import { bundles } from './data/index';

export const DEFAULT_LANGUAGE = 'en';

// English is the source language and always available; every other entry is
// a bundled translation package, labelled in its own language.
export const LANGUAGES = [
  { code: DEFAULT_LANGUAGE, label: 'English' },
  ...Object.entries(bundles).map(([code, bundle]) => ({ code, label: bundle.label || code })),
];

export const isLanguage = (code) => LANGUAGES.some((language) => language.code === code);
